import React, { useState, useEffect } from "react";
import "./Upcomming_test.css";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { db, storage } from "../../../firebase";

const Upcomming_test = () => {
  const [examDates, setExamDates] = useState([]); // 🔹 dynamic dates

  useEffect(() => {
    const fetchExamDates = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "testSchedule_db"));
        const today = new Date();
        today.setHours(0, 0, 0, 0); // normalize to midnight

        const dates = querySnapshot.docs
          .map((doc) => doc.data().date) // "2026-03-03"
          .map((dateStr) => {
            const d = new Date(dateStr);
            d.setHours(0, 0, 0, 0); // normalize
            return d;
          })
          .filter((date) => date >= today)
          .sort((a, b) => a - b);

        setExamDates(dates);
      } catch (error) {
        console.error("Error fetching exam dates:", error);
      }
    };

    fetchExamDates();
  }, []);
  return (
    <div className="notifications">
      <div className="notification__">
        <div className="upload_date">Session 2025 - 2026</div>
        <hr style={{ width: "100%" }}></hr>
        <div className="notification__heading">
          K-SAT (Kinematics Scholastic Aptitude Test)
        </div>
        <ul>
          {examDates.map((date, index) => {
            const formatted = date.toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }); // e.g. "March 3, 2026"
            return (
              <li key={formatted} value={formatted}>
                <a href="https://kinematicsclasses.com/ksat" target="_blank" rel="noopener noreferrer" >
Test {index + 1} Starts on 
<span className="date">{formatted}</span>
                </a>
                
              </li>
            );
          })}
        </ul>
      </div>
      <hr style={{ width: "100%" }}></hr>
    </div>
  );
};

export default Upcomming_test;
